import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Scan } from 'src/app/interfaces/scan.interfaces';
import { environment } from 'src/environments/environment';

interface TableRow {
  id: number;
  image: string;
  name: string;
  ncc: string;
  objectClass: string;
  huell: string;
  shields: string;
  player: { id: number; name: string };
}

@Component({
  standalone: false,
  selector: 'app-sector-details',
  templateUrl: './sector-details.component.html',
})
export class SectorDetailsComponent implements OnInit, OnChanges {
  @Input() scan: Scan | undefined;
  tableRows: TableRow[] = [];

  constructor() { }

  ngOnInit(): void {
    this.buildTableRows();
  }

  ngOnChanges(): void {
    this.buildTableRows();
  }

  private buildTableRows() {
    if (!this.scan) {
      this.tableRows = [];
      return;
    }

    const colonies = this.scan.scanObjects
      .filter((obj) => obj.objectClass === 'Kolonie')
      .map((colony) => ({
        id: colony.id,
        image: `${environment.imageUrl}/planets/${colony.image}.gif`,
        name: colony.name,
        ncc: '-',
        objectClass: colony.objectClass,
        huell: '',
        shields: '',
        player: colony.owner,
      }));

    const ships = this.scan.scanObjects
      .filter((obj) => obj.objectClass !== 'Kolonie')
      .map((ship) => ({
        id: ship.id,
        image: `${environment.imageUrl}/ships/${ship.image}.gif`,
        name: ship.name,
        ncc: ship.ncc,
        objectClass: ship.objectClass,
        huell: ship.shieldsActive ? `${ship.huell}/${ship.huellMax}` : '-',
        shields: ship.shieldsActive ? `${ship.shields}/${ship.shieldsMax}` : '-',
        player: ship.owner,
      }));

    this.tableRows = [...colonies, ...ships];
  }
}
